import { DraggableProvided, DraggableStateSnapshot } from '@hello-pangea/dnd';
import { twMerge } from 'tailwind-merge';
import { AnswerContent } from '@/components/question/view/primitives/shared/AnswerContent';
import { DnDToken, Flow } from '@/utils/questions/dnd/types';
import { resolveAnswerContentKind } from '@/utils/questions/resolveAnswerContentKind';

type ChipBoxProps = {
  token: DnDToken;
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  disabled?: boolean;
  testId?: string;
  flow?: Flow;
  className?: string;
  fadingOut?: boolean;
  selected?: boolean;
  onSelect?: () => void;
};

export function ChipBox({
  token,
  provided,
  snapshot,
  disabled,
  testId,
  className,
  flow,
  fadingOut,
  selected,
  onSelect,
}: ChipBoxProps) {
  const label = token.content.text ?? token.content.altText ?? undefined;
  const kind = resolveAnswerContentKind(token.content);
  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      data-testid={testId}
      aria-label={label}
      onClick={event => {
        if (event.defaultPrevented) return;
        event.stopPropagation();
        onSelect?.();
      }}
      className={twMerge(
        'inline-flex min-h-12 min-w-12 items-center justify-center gap-1.5 rounded-lg border border-base-300 bg-base-200 px-5 font-poppins font-600 text-lg text-base-content shadow-sm transition-opacity duration-150',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary',
        kind === 'image' && 'p-1',
        !disabled && 'cursor-grab',
        flow === 'vertical' && 'w-full',
        snapshot.isDragging && 'shadow-lg',
        selected && 'ring-2 ring-secondary',
        fadingOut && 'opacity-0',
        className,
      )}
    >
      <AnswerContent answer={token.content} />
    </div>
  );
}
